module.exports = __webpack_public_path__ + "img/guess-number-details2.2ba3a726.png";